/** Tek AI sayfasının sekme metinleri. */

import type { TranslationBundle } from '../../shell/bridge.ts';

export const TEXTS: TranslationBundle = {
  en: {
    aip_nav: 'AI',
    aip_doc: 'Document', aip_tpl: 'Template', aip_asst: 'Assistant',
    aip_tpl_t: 'Fill from a template',
    aip_tpl_d: 'Upload one reference document and mark its fields once; later documents fill in the same way.',
    aip_tpl_soon: 'Coming soon',
    aip_tpl_upload: '+ Upload a reference document (PDF)',
    aip_tpl_pick: 'Which fields belong in the template? The ones you tick fill in automatically next time.',
    aip_tpl_name: 'Template name', aip_tpl_save: 'Save', aip_tpl_saved: 'Saved templates',
    aip_tpl_none: 'No templates yet.', aip_tpl_fields: 'fields', aip_tpl_del: 'Delete',
    aip_tpl_saved_ok: 'Template saved.', aip_tpl_needname: 'Give the template a name.',
    aip_tpl_needfield: 'Pick at least one field.', aip_tpl_save_fail: 'Could not save the template.',
    aip_tpl_notext: 'This PDF has no text layer — a template cannot be derived.',
    aip_tpl_nofields: 'No anchorable fields found in this document.',
  },
};
